var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "home"
  }, [_c('img', {
    attrs: {
      "alt": "Anima logo",
      "src": require("../assets/logo.png")
    }
  }), _c('span', [_vm._v("Welcome to Anima's admin panel.")]), _c('span', [_vm._v("Unfortunately, this page is still under constructions, so try again later! :)")])]);

}]

export { render, staticRenderFns }